import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/services/auth.service";

interface ImpersonableUser {
  id: string;
  name: string;
  email: string;
  role?: { name?: string };
}

/**
 * "Ver como": o MASTER escolhe um utilizador da sua entidade e passa a ver o
 * sistema como ele, só em leitura. A sessão continua a ser a do MASTER.
 */
@Component({
  selector: "app-impersonation-modal",
  templateUrl: "./impersonation-modal.component.html",
})
export class ImpersonationModalComponent implements OnInit {
  users: ImpersonableUser[] = [];
  userId: string | null = null;
  loading = false;
  submitting = false;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.authService.getImpersonableUsers().subscribe({
      next: (users) => {
        this.users = users ?? [];
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.showError(error);
      },
    });
  }

  searchUser(term: string, item: ImpersonableUser): boolean {
    const t = term.toLowerCase();
    return (
      item.name?.toLowerCase().includes(t) ||
      item.email?.toLowerCase().includes(t)
    );
  }

  confirm(): void {
    if (!this.userId || this.submitting) return;
    this.submitting = true;
    this.authService.startImpersonation(this.userId).subscribe({
      next: () => {
        this.authService.removeEntityLogo();
        location.href = location.origin;
      },
      error: (error) => {
        this.submitting = false;
        this.showError(error);
      },
    });
  }

  private showError(error: any): void {
    const message = error?.error?.message;
    this.toastr.error(
      this.translate.instant(
        typeof message === "string" && message.startsWith("t-")
          ? message
          : "t-impersonation-not-allowed",
      ),
    );
  }
}
